module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "sp",
    attrs: {
      "id": "ack"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "FM-Head-fmh"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ack",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "Text-Std-No-Indent-tx1"
  }, [_vm._v("Writing a book—like planning a wedding—takes a lot of time, patience, and the sometimes irrational belief that it will all work out in the end. I want to thank the following people who helped walk me down the aisle: My agent, Adam Chromy, whose early notes helped give this book its heart and soul; Dan Weiss, who heard my idea for "), _c('span', {
    staticClass: "ePub-I"
  }, [_vm._v("The Wedding Sisters")]), _vm._v(" over lunch and said let’s do it; my editor, Vicki Lame, who patiently gave me what I needed for this one: time to figure it out! And my college friend Dana Bash, who in making time to say “hi” one busy workday, gave me an unexpected but invaluable behind-the-scenes look at political journalism. A special thanks to professor and memoirist Dori Katz, who so candidly and generously shared her story with the congregants at Temple Emanu-El and inspired me greatly.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Thanks to my daughters, Bronwen and Georgia, who show me—every day—the remarkable beauty of sisterhood.")]), _vm._v(" "), _c('p', {
    staticClass: "Text-Standard-tx"
  }, [_vm._v("Finally, I thank my beloved husband, who makes my dreams come true.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d01ac2ca","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0